import _ from 'lodash';
import { Message } from 'element-ui';

export const DEFAULT_MESSAGE_DURATION = 8000;

const defaultOptions = {
  showClose: true,
  duration: DEFAULT_MESSAGE_DURATION,
};

export const showMessage = (message, options = {}) => {
  const parsedMessage = (_.isArray(message)) ? message.join(', ') : message;

  Message({
    ...defaultOptions,
    message: parsedMessage,
    ...options,
  });
};

export const showSuccessMessage = (message, options = {}) => {
  showMessage(message, {
    type: 'success',
    ...options,
  });
};

export const showErrorMessage = (message, options = {}) => {
  showMessage(message, {
    type: 'error',
    ...options,
  });
};

export const showWarningMessage = (message, options = {}) => {
  showMessage(message, {
    type: 'warning',
    ...options,
  });
};



// WEBPACK FOOTER //
// ./src/ui/message.js